




































import { gsap } from "gsap";
import TheJ05NotificationPanelThanks from "@/general/components/pages/parts/ThanksPointMessage/TheJ05NotificationPanelThanks.vue";
import TheJ05ChatScreen from "@/general/components/pages/parts/ThanksPointMessage/TheJ05ChatScreen.vue";
import TheJ05ChatForms from "@/general/components/pages/parts/ThanksPointMessage/TheJ05ChatForms.vue";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";
import thanksChat from "@/general/store/modules/thanksChat";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import ThanksPointApi from "@/general/api/thanksPointApi";
import {
  ListResponse,
  ThankPointMessage,
  ThanksPointMessageHasRead
} from "@/general/store/models";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";
import loginInfo from "@/general/store/modules/loginInfo";
import AuthApi from "@/general/api/authApi";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";

@Component({
  name: "ThanksPointMessage",
  components: {
    TheJ05NotificationPanelThanks,
    TheJ05ChatScreen,
    TheJ05ChatForms
  },
  directives: {
    scroll(el: any, binding: any) {
      const f = function(evt: any) {
        if (binding.value(evt, el)) {
          window.removeEventListener("scroll", f);
        }
      };
      window.addEventListener("scroll", f);
    }
  }
})
export default class ThanksPointMessage extends Vue {
  @Prop({ type: [Array], required: true }) tempChat!: any;
  @Prop({ type: Boolean, required: false, default: false }) ssoFlg!: boolean;

  threadId = 1;
  messagePk!: number;
  lastMsgPk!: number;
  senderText = "";
  title = "";

  pageYOffset = window.pageYOffset || document.documentElement.scrollTop;

  breadcrumb: any = [];

  fitInsideFormState = false;
  element: any = {
    content: {},
    textareaElement: {},
    theHeader: {}
  };
  internalChatLog: any = [];
  stateThreadId = thanksChat.threadId;
  chatLog: any = [];
  userInfo = commons.userInfo;
  unreadKeyNo = 0;
  firstMessage: any = null;

  @Watch("fitInsideFormState")
  onFitInsideFormState() {
    const state = this.fitInsideFormState;
    if (state == true) {
      this.animationFitInsideForm();
    } else {
      this.animationFixedToOutsideForm();
    }
  }

  @Watch("chatLog")
  onChatLog() {
    this.internalChatLog = this.chatLog;
  }

  @Watch("isSp")
  onIsSp() {
    this.initTextareaElementHeight();
  }

  get pointNotifications() {
    let messageCardDetails: any = LocalStorage.getItem(
      "messageCardDetails"
    ) as string;
    messageCardDetails = JSON.parse(messageCardDetails);

    if (messageCardDetails?.point?.state === "sent" || messageCardDetails?.point?.state === "given") {
      this.senderText = "送り先";
      this.title = this.thanksPointName1 + `を
                    送付しました！`;
    } else {
      this.senderText = "送り元";
      this.title = this.thanksPointName1 + `が
                    届いています！`;
    }
    // DC_IC-942
    return {
      giver: {
        id: messageCardDetails?.id == 0 ? "" : messageCardDetails?.id,
        user_id:
          messageCardDetails?.user_id == 0 ? "" : messageCardDetails?.user_id,
        name: messageCardDetails?.id == 0 ? "－" : messageCardDetails?.name,
        icon: {
          original: "",
          large: "",
          medium:
            messageCardDetails?.id == 0 ? "" : messageCardDetails?.icon?.medium,
          small: ""
        }
      },
      point: messageCardDetails?.point?.total
    };
  }
  get pageSize() {
    return commons.pageSize ? commons?.pageSize : 10;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  get thread_enabled(){
    return auth.user.thread_enabled;
  }

  get thanksPointName1() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  get thanksPointName2() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }

  async created() {
    this.ssoFlg = loginInfo.isSso;
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const thankGivingsIdParam = urlParams.get("id");
    const thanksGivingId = thankGivingsIdParam as string;
    const search = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";

    this.breadcrumb = [
      {
        text: "",
        url: SITE_MAP.TOP_PAGE,
        pageType: "home"
      },
      {
        text: this.thanksPointName2 + "メッセージ",
        url:
          search === ""
            ? SITE_MAP.THANKS_POINT
            : SITE_MAP.THANKS_POINT + "?search=" + search,
        pageType: "lower"
      },
      {
        text: "メッセージ詳細",
        url: "",
        pageType: "lower"
      }
    ];

    await commons.setbreadcrumb(this.breadcrumb);
    this.messagePk = parseInt(thanksGivingId);

    const response: ListResponse<ThankPointMessage> = await ThanksPointApi.getThanksPointMessageList(
      1,
      this.pageSize,
      this.messagePk
    );

    if (typeof response === "undefined" || response.status == "404") {
      window.location.href = "/error-not-found";
    }
  
    // DC_IC-942
    if (response.results && response.results.length > 0) {
      this.firstMessage = response.results[0];
      response.results?.forEach((resObj) => {
        this.chatLog.push({
          id:
            resObj?.sender_is_logged_in_user === true
              ? resObj?.from_user?.id == 0
                ? ""
                : resObj?.from_user?.id
              : resObj?.to_user?.id,
          name:
            resObj?.sender_is_logged_in_user === true
              ? resObj?.from_user?.id == 0
                ? "－"
                : resObj?.from_user?.user_name
              : resObj?.to_user?.user_name,
          icon: {
            original: "",
            large: "",
            medium:
              resObj?.from_user?.id == 0
                ? ""
                : this.pointNotifications.giver.icon.medium,
            small: ""
          },
          date: resObj.created_at,
          message: resObj.message,
          unread: true,
          title: resObj?.thanks_giving_title ? resObj.thanks_giving_title : "",
          isYouSent: resObj.sender_is_logged_in_user
        });
      });
    }

    this.lastMsgPk = response?.results?.slice(-1)[0].pk as number;

    const updateRes: ThanksPointMessageHasRead = await ThanksPointApi.patchThanksPointMessage(
      this.messagePk,
      undefined,
      undefined,
      true
    );
  }

  async mounted() {
    await this.initRegistData();
    AuthStorage.checkLogin();
    setTimeout(() => {
      this.fitInsideFormState = true;
      this.scrollToBottom();
    }, 1000);
  }

  initTextareaElementHeight() {
    const textareaElement = this.element.textareaElement;
    if (!textareaElement) return false;
    gsap.set(textareaElement, {
      height: ""
    });
    return true;
  }

  initRegistData() {
    const refs = this.$refs;
    const { content } = refs;
    const { textareaElement } = refs;
    const { theHeader } = refs;

    this.element = { content, textareaElement, theHeader };
  }

  fixedForms() {
    const contentRect = this.element.content.getBoundingClientRect();
    const height = {
      contentHeight: this.element.content.clientHeight,
      form: this.element.textareaElement.clientHeight,
      windowHeight: window.innerHeight
    };

    const calcHeight = height.contentHeight - height.windowHeight;

    const triggerPosition = contentRect.top + this.pageYOffset + calcHeight;

    this.controlTheFormFixation(this.pageYOffset > triggerPosition);
  }

  controlTheFormFixation(state: any) {
    this.fitInsideFormState = state;
  }

  animationFitInsideForm() {
    if (this.element.textareaElement == undefined && this.thread_enabled) {
      window.location.reload();
      return;
    }

    const tl = gsap.timeline();
    const speed = 0.15;

    tl.to(this.element.textareaElement, speed * 2, {
      y: "100%",
      autoAlpha: 0
    })
      .set(this.element.textareaElement, {
        maxHeight: "0",
        position: "relative",
        y: "0%"
      })
      .to(this.element.textareaElement, speed, {
        autoAlpha: 1
      })
      .to(this.element.textareaElement, speed * 2, {
        maxHeight: this.element.textareaElement.clientHeight
      });
  }

  animationFixedToOutsideForm() {
    const tl = gsap.timeline();
    const speed = 0.15;

    tl.to(this.element.textareaElement, speed, {
      y: "100%",
      autoAlpha: 0
    })
      .to(this.element.textareaElement, speed, {
        autoAlpha: 1
      })
      .to(this.element.textareaElement, speed, {
        y: "0%",
        position: "fixed"
      });
  }

  async doSend(value: any) {
    const to_user_id =
      auth.user?.user_id == this.firstMessage?.from_user?.id
        ? this.firstMessage?.to_user?.id
        : this.firstMessage?.from_user?.id;
    const response: ThankPointMessage = await ThanksPointApi.postThanksPointMessage(
      to_user_id,
      value.message,
      this.lastMsgPk,
      this.messagePk
    );

    if (response.status == 500) {
      if (this.ssoFlg) {
        // SSOログイン時は行き止まりエラー画面へ
        window.location.href = "/session-time-out/";
      } else {
        LocalStorage.removeAll();
        AuthApi.getLogout();
        auth.remove();
        window.location.href = "/system-error/";
      }
      return;
    }

    if (!response?.created_at) {
      return;
    }

    value.isYouSent = true;
    value.date = response.created_at;

    const internalChatLog = this.internalChatLog;
    const userInfo = this.userInfo;
    const internalChatLogArray = internalChatLog;
    const doSendObject = Object.assign(value, userInfo);
    const sendMessage = () => {
      internalChatLogArray.push(doSendObject);
      thanksChat.addChatLog(internalChatLogArray);
    };
    await sendMessage();

    this.scrollToBottom();
  }

  scrollToBottom() {
    const pageYOffset = this.pageYOffset;
    const content = this.element.content;
    const elementHeight = {
      content: content.clientHeight,
      window: window.innerHeight
    };
    const scrollTo = pageYOffset + elementHeight.content;
    window.scrollTo(0, scrollTo);
  }
}
